// Original geometric diagrams for service modules — no stock icons.
// Thin 1px strokes, glowing nodes, animated dashed flow lines.

const S = "#6B86A8";
const B = "#E7E9EC";
const R = "#8A93A1";

const Node = ({ cx, cy, r = 3 }) => (
  <>
    <circle cx={cx} cy={cy} r={r + 4} fill={B} opacity="0.12" />
    <circle cx={cx} cy={cy} r={r} fill={B} />
  </>
);

const wrap = (children) => (
  <svg viewBox="0 0 120 90" className="h-full w-full" fill="none" aria-hidden="true">
    {children}
  </svg>
);

export default function ServiceDiagram({ type = "grid", className = "" }) {
  const diagrams = {
    grid: wrap(
      <>
        {[0, 1, 2, 3].map((i) => (
          <line key={`v${i}`} x1={24 + i * 24} y1="14" x2={24 + i * 24} y2="76" stroke={S} strokeOpacity="0.35" strokeWidth="1" />
        ))}
        {[0, 1, 2].map((i) => (
          <line key={`h${i}`} x1="18" y1={26 + i * 22} x2="102" y2={26 + i * 22} stroke={S} strokeOpacity="0.35" strokeWidth="1" />
        ))}
        <rect x="46" y="26" width="24" height="22" fill={R} fillOpacity="0.18" stroke={B} strokeWidth="1" />
        <Node cx="48" cy="26" /><Node cx="72" cy="48" />
      </>
    ),
    orbit: wrap(
      <>
        <ellipse cx="60" cy="45" rx="42" ry="16" stroke={S} strokeOpacity="0.4" strokeWidth="1" />
        <ellipse cx="60" cy="45" rx="24" ry="34" stroke={S} strokeOpacity="0.25" strokeWidth="1" />
        <circle cx="60" cy="45" r="7" fill={R} fillOpacity="0.25" stroke={B} strokeWidth="1" />
        <Node cx="102" cy="45" /><Node cx="60" cy="11" /><Node cx="30" cy="60" r="2.5" />
      </>
    ),
    funnel: wrap(
      <>
        <path d="M20 18 H100 L74 46 V70 L46 70 V46 Z" stroke={S} strokeOpacity="0.4" strokeWidth="1" />
        <line className="kv-flow" x1="60" y1="20" x2="60" y2="68" stroke={B} strokeWidth="1" />
        <Node cx="60" cy="70" />
        <line x1="30" y1="30" x2="90" y2="30" stroke={S} strokeOpacity="0.25" strokeWidth="1" />
      </>
    ),
    hub: wrap(
      <>
        <circle cx="60" cy="45" r="9" fill={R} fillOpacity="0.2" stroke={B} strokeWidth="1" />
        {[[24, 20], [96, 20], [20, 66], [100, 66], [60, 12], [60, 78]].map(([x, y], i) => (
          <g key={i}>
            <line className={i % 2 ? "kv-flow" : ""} x1="60" y1="45" x2={x} y2={y} stroke={S} strokeOpacity="0.4" strokeWidth="1" />
            <Node cx={x} cy={y} r="2.5" />
          </g>
        ))}
      </>
    ),
    wave: wrap(
      <>
        <path d="M14 45 Q30 20 46 45 T78 45 T110 45" stroke={B} strokeWidth="1.2" />
        <path d="M14 55 Q30 32 46 55 T78 55 T110 55" stroke={S} strokeOpacity="0.35" strokeWidth="1" />
        <Node cx="14" cy="45" /><Node cx="110" cy="45" />
      </>
    ),
    stack: wrap(
      <>
        {[0, 1, 2, 3].map((i) => (
          <g key={i}>
            <rect x="34" y={20 + i * 14} width="52" height="9" stroke={S} strokeOpacity="0.4" strokeWidth="1" fill={i === 1 ? R : "none"} fillOpacity="0.18" />
          </g>
        ))}
        <line className="kv-flow" x1="60" y1="20" x2="60" y2="70" stroke={B} strokeWidth="1" />
        <Node cx="86" cy="24.5" r="2.5" /><Node cx="34" cy="66.5" r="2.5" />
      </>
    ),
  };
  return <div className={className}>{diagrams[type] || diagrams.grid}</div>;
}
